import React, {
  ChangeEvent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react'

import TopSpeakers from './components/top-speakers'
import SearchByLaw from './components/search-by-law'
import Sectors from './components/sectors'
import VideoPlayer from 'cwp-components/Multimedia/VideoPlayer'
import PublishedCategories from './components/published-categories'
import downloadIcon from 'assets/download_icon.svg'
import { Button } from 'common/components/Authentication/Button'
import InterviewCard from 'cwp-components/cards/InterviewCard'
import InterviewList from 'cwp-components/cards/InterviewList'
import { InputGroupField, SelectField } from 'cwp-components/forms'
import { BsSearch } from 'react-icons/bs'
import { Newsletter } from 'cwp-components/Newsletter'
import {
  SORT_OPTIONS,
  useInterviewTemplate,
} from 'common/hooks/useInterviewTemplate'

const SvgIcon = ({ src, alt, ...props }) => (
  <img src={src} alt={alt} {...props} />
)

const pageSize = 6

const InterviewPage = () => {
  const videoRef = useRef<HTMLVideoElement>(null)
  const {
    results,
    sortOption,
    setSortOption,
    searchValue,
    updateSearchValue,
    loadMore,
    hasNext,
    topSpeakers,
    mostPublishedCategory,
    mostViewed,
    sectors,
    tags,
    latestInterview,
    loadInterviews,
    loadMostPublishedCategory,
    loadMostViewed,
    loadSectors,
    loadSpeakers,
    loadTags,
  } = useInterviewTemplate({ pageSize })

  useEffect(loadInterviews, [loadInterviews])
  useEffect(loadMostPublishedCategory, [loadMostPublishedCategory])
  useEffect(loadMostViewed, [loadMostViewed])
  useEffect(loadSectors, [loadSectors])
  useEffect(loadSpeakers, [loadSpeakers])
  useEffect(loadTags, [loadTags])

  const [filteredTags, setFilteredTags] = useState<any>(tags)

  const onSortDropdownSelect = (e: any) => {
    setSortOption(
      SORT_OPTIONS.find((filter) => filter.value === e.target.value),
    )
  }

  const handleSearchInputChange = useCallback(
    (evt: ChangeEvent<HTMLInputElement>) => {
      updateSearchValue(evt.target.value)
    },
    [],
  )

  return (
    <div className={''}>
      <div className='bg-gradient-to-r from-[10%] from-[#fff] to-[100%] to-[#EBF3FF] md:p-[180px_140px_90px] p-[40px_16px]'>
        <div className='text-[18px] md:text-[40px] text-[#101828] font-bold '>
          Most viewed
        </div>
        <div className='grid md:grid-cols-3 md:mt-[50px] mt-[12px] md:gap-[80px] gap-[48px]'>
          {mostViewed?.slice(0, 3).map((interview) => (
            <InterviewCard key={interview.id} {...interview} />
          ))}
        </div>

        <div className='md:mt-[300px] mt-[60px] text-[18px] md:text-[40px] text-[#101828] font-bold'>
          Latest
        </div>
        <div className='md:m-[50px] mt-[16px] space-y-[20px] '>
          {latestInterview.map((interview) => (
            <InterviewList key={interview.id} data={interview} />
          ))}
        </div>
      </div>

      <div className='md:m-[80px_0px_300px] m-[80px_16px_80px]'>
        <div className='flex items-end text-end justify-end space-x-4 ml-[30vw] sm:ml-0'>
          <Button variant='quaternary' className='text-sm'>
            <SvgIcon
              src={downloadIcon}
              alt='Download'
              className='w-4 h-4 mr-2'
            />
            Download transcript
          </Button>
        </div>
        <VideoPlayer
          ref={videoRef}
          src='https://www.youtube.com/embed/dHqg2urvK1s?enablejsapi=1'
          isYouTube
          title='Interview with John Doe'
          interviewee='John Doe'
        />
      </div>

      <div className='grid md:grid-cols-[auto_417px]  gap-[100px] md:mx-[140px] mx-[16px]'>
        <div className=''>
          <div className='text-[18px] md:text-[40px] text-[#101828] font-bold'>
            Life through the legal lens
          </div>
          <div className='m-[50px_0px_32px] flex flex-wrap gap-[20px]'>
            <InputGroupField
              placeholder='Type what you are searching for...'
              Icon={BsSearch}
              reverse
              value={searchValue}
              className='md:w-[586px] w-full'
              onChange={handleSearchInputChange}
            />

            <SelectField
              name='sort'
              records={SORT_OPTIONS}
              defaultValue={sortOption.value}
              onChange={onSortDropdownSelect}
              className={'md:w-[250px] w-[200px]'}
            />
            <button className='text-text-muted max-sm:text-[12px] '>
              Clear filters
            </button>
          </div>

          <div className='grid md:grid-cols-2  gap-[69px] mb-4'>
            {results?.map((interview) => (
              <InterviewCard key={interview.id} {...interview} />
            ))}
          </div>
          {!!hasNext && (
            <div className='flex justify-end mt-[20px]'>
              <button onClick={loadMore} className='text-underline'>
                See more
              </button>
            </div>
          )}
        </div>

        <div className='space-y-[120px] max-sm:mx-[20px] '>
          <TopSpeakers speakers={topSpeakers} />
          <SearchByLaw
            tags={tags}
            filteredTags={filteredTags}
            setTags={setFilteredTags}
          />
          <Sectors sectors={sectors} />
          <PublishedCategories categories={mostPublishedCategory} />
        </div>
      </div>
      <Newsletter />
    </div>
  )
}

export default InterviewPage
